<template>
 <div class="card">
    <div class="card-body">
      <div class="section-heading" align="center">INSTRUCTIONS</div>
      <h4>
        Portal follows below process to conduct the campus recruitment test and provide results.
      </h4>
      <ol>
        <li>Add campus</li>
        <li>Add users to the campus</li>
        <li>Send welcome email</li>
        <li>Create test sets</li>
        <li>Assign test to the campus</li>
        <li>Create a result summary</li>
      </ol>
      <p><strong>Add Campus - </strong>Please add name of the campus you are visiting. This name will work as a unique identifier for the campus.</p>
      <p><strong>Add Users - </strong>Users are required to be added to the campus. There are two ways to add users. Admin can add users one by one using “Create Single User” or can upload an excel of details to bulk create using “Create Multiple Users”. Portal provides functionality to add dummy users for students attending the test without prior enrolment. Admin can see all the users added to the particular campus using “Current Users”</p>
      <p><strong>Welcome Mail - </strong>This will send out a welcome email and login credentials to all the users added to the selected campus</p>
      <p><strong>Create Question - </strong>This is a question creation wizard. Image, graph or text can be used to create questions. In the next step, these questions will be used to create tests.</p>
      <p><strong>Create Test - </strong>This feature will create a test by adding multiple questions. You can create a test using questions already added to the portal or adding new questions. You can see 3 sections - all the tests need to have 20 questions - 10,5,5 is a split between the sections. You can also add instructions to be shown on the portal prior to the test.</p>
      <p><strong>Create Test Sets -  </strong>To avoid cheating, the same campus will see multiple tests randomly allotted to the students. You have to create a test set by adding more than one test. These selected number of tests will be allocated to the particular campus. We recommended at least 10 tests to be part of the test set for each campus</p>
      <p><strong>Assign Test to Campus - </strong>Students will not be able to see the test on login unless test set has been assigned to the particular. Please ask students to try login in when you are on campus. After solving issues of a few students, ask all of them to log out. Then assign the test set to the campus and ask them to re-login. This time tests will be visible to students’ login. If someone still has an issue, provide dummy id from the list of dummy users.</p>
      <p><strong>Download Results - </strong>You can see the section wise results for all the users who have successfully submitted the test. You can also download and use this results for shortlisting for further rounds of the selection process.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue